import { TExchange, TMarket, TPair, TType, getHeaders, withRetry } from "@root/common";
import { API_BASE_URL } from "../const";


export async function getExchanges(): Promise<TExchange[]> {
    try {
        const response = await withRetry(async () => await fetch(`${API_BASE_URL}/exchanges`, {
            headers: await getHeaders(),
        }))

        const json = await response.json()
        return json.markets
    } catch (err) {
        return [];
    }
}

export async function getMarkets(type: TType): Promise<Record<string, TMarket[]>> {
    try {
      const response = await withRetry(async () => await fetch(`${API_BASE_URL}/markets/${type}`, {
        headers: await getHeaders(),
      })) 
      const json = await response.json()

      if (type === 'spot') {
          for (const key of Object.keys(json)) {
              json[key] = json[key].map((val: string) => ({exchange: val, funding: undefined}))
          }
      }

      if (type === 'margin') {
          for (const key of Object.keys(json)) {
              json[key] = json[key].map((val: string) => ({exchange: val, funding: undefined}))
          }
      }

      return json
    } catch (err) {
      return {};
    }
}

export async function getPairs(type: TType): Promise<TPair[]> {
    try {
        const response = await withRetry(async () => await fetch(`${API_BASE_URL}/pairs/${type}`, {
            headers: await getHeaders(),
        }))

        const json = await response.json()
        return json
    } catch (err) {
        return [];
    }
}
